import logoBrandStarter from '../assets/logo_brandstarter.png';
import { useState, useRef, useEffect } from 'react';
import { api } from '../services/api';

// ─── STYLES ──────────────────────────────────────────────────
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,600;0,700;1,500&family=Inter:wght@300;400;500;600;700&display=swap');
  :root{--g:#173B34;--o:#E4572E;--c:#F6F2EC;--d:#222222;--line:#EDE9E2;}
  .ma{font-family:'Inter',sans-serif;color:var(--d);}
  .ma-progress{height:3px;background:var(--line);border-radius:2px;margin-bottom:32px;overflow:hidden;}
  .ma-progress-fill{height:100%;background:linear-gradient(90deg,var(--g),var(--o));border-radius:2px;transition:width .4s ease;}

  /* CONTEXTE BANNER */
  .ma-context{background:rgba(23,59,52,0.05);border:1px solid rgba(23,59,52,0.12);border-radius:14px;padding:14px 18px;margin-bottom:28px;display:flex;align-items:flex-start;gap:12px;}
  .ma-context-ico{font-size:16px;flex-shrink:0;margin-top:1px;}
  .ma-context-text{font-size:13px;color:#444;line-height:1.6;}
  .ma-context-text strong{color:var(--g);font-weight:700;}
  .ma-context-tags{display:flex;flex-wrap:wrap;gap:5px;margin-top:8px;}
  .ma-tag{font-size:11.5px;padding:3px 10px;border-radius:999px;background:rgba(23,59,52,0.08);color:var(--g);font-weight:600;border:1px solid rgba(23,59,52,0.15);}

  /* FORMATION */
  .ma-formation{max-width:720px;margin:0 auto;}
  .ma-part{margin-bottom:44px;}
  .ma-eyebrow{display:inline-flex;align-items:center;gap:8px;font-size:10.5px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;color:var(--o);margin-bottom:14px;}
  .ma-eyebrow::before{content:'';width:18px;height:2px;background:var(--o);display:inline-block;}
  .ma-part h2{font-family:'Playfair Display',serif;font-size:clamp(20px,2.5vw,26px);color:var(--g);font-weight:700;line-height:1.2;margin-bottom:14px;}
  .ma-part p{font-size:15px;color:#555;line-height:1.75;margin-bottom:14px;font-weight:300;}
  .ma-part strong{color:var(--d);font-weight:600;}

  .ma-hl{background:rgba(23,59,52,0.07);border-left:3px solid var(--g);border-radius:0 12px 12px 0;padding:16px 20px;margin:16px 0;font-size:14.5px;color:#333;line-height:1.65;}
  .ma-hl.orange{background:rgba(228,87,46,0.07);border-left-color:var(--o);}

  .ma-grid{display:grid;grid-template-columns:1fr 1fr;gap:12px;margin:16px 0;}
  .ma-gi{background:#fff;border:1px solid var(--line);border-radius:12px;padding:16px 18px;}
  .ma-gi-ico{font-size:20px;margin-bottom:8px;}
  .ma-gi-title{font-size:13.5px;font-weight:700;color:var(--g);margin-bottom:5px;}
  .ma-gi-desc{font-size:12.5px;color:#777;line-height:1.55;}

  .ma-canal-grid{display:grid;grid-template-columns:repeat(2,1fr);gap:10px;margin:16px 0;}
  .ma-canal{background:#fff;border:1px solid var(--line);border-radius:12px;padding:14px 16px;}
  .ma-canal-head{display:flex;align-items:center;gap:8px;margin-bottom:8px;}
  .ma-canal-ico{font-size:16px;}
  .ma-canal-name{font-size:13px;font-weight:700;color:var(--g);}
  .ma-canal-quand{font-size:11.5px;color:var(--o);font-weight:600;margin-bottom:5px;}
  .ma-canal-desc{font-size:12px;color:#777;line-height:1.55;}

  .ma-funnel{display:flex;flex-direction:column;gap:0;margin:16px 0;}
  .ma-funnel-step{display:flex;gap:14px;padding:14px 16px;background:#fff;border:1px solid var(--line);position:relative;}
  .ma-funnel-step:first-child{border-radius:12px 12px 0 0;}
  .ma-funnel-step:last-child{border-radius:0 0 12px 12px;}
  .ma-funnel-step:not(:last-child){border-bottom:none;}
  .ma-funnel-num{width:28px;height:28px;border-radius:50%;background:var(--g);color:#fff;display:flex;align-items:center;justify-content:center;font-size:12px;font-weight:700;flex-shrink:0;margin-top:1px;font-family:'Playfair Display',serif;}
  .ma-funnel-step strong{display:block;font-size:13.5px;color:var(--d);margin-bottom:3px;}
  .ma-funnel-step span{font-size:12.5px;color:#777;line-height:1.55;}

  .ma-3q{display:grid;grid-template-columns:repeat(3,1fr);gap:10px;margin:16px 0;}
  .ma-3q-item{background:var(--g);border-radius:12px;padding:16px;}
  .ma-3q-ico{font-size:20px;margin-bottom:8px;}
  .ma-3q-q{font-family:'Playfair Display',serif;font-size:14px;color:#fff;font-weight:600;line-height:1.4;}

  .ma-metriques{display:grid;grid-template-columns:repeat(3,1fr);gap:10px;margin:16px 0;}
  .ma-met{background:#fff;border:1px solid var(--line);border-radius:12px;padding:14px;text-align:center;}
  .ma-met-ico{font-size:18px;margin-bottom:6px;}
  .ma-met-name{font-size:12px;font-weight:700;color:var(--g);margin-bottom:3px;}
  .ma-met-desc{font-size:11px;color:#999;line-height:1.4;}

  .ma-clara{display:flex;align-items:flex-start;gap:14px;background:#fff;border:1px solid var(--line);border-radius:14px;padding:18px;margin:18px 0;}
  .ma-clara-av{width:38px;height:38px;border-radius:50%;background:var(--g);display:flex;align-items:center;justify-content:center;font-family:'Playfair Display',serif;font-weight:700;font-size:15px;color:var(--o);flex-shrink:0;}
  .ma-clara-name{font-size:10.5px;font-weight:700;color:var(--g);letter-spacing:.06em;text-transform:uppercase;margin-bottom:5px;}
  .ma-clara-text{font-size:13.5px;color:#444;line-height:1.65;font-style:italic;font-family:'Playfair Display',serif;}

  .ma-lead-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:10px;margin:14px 0;}
  .ma-lead{background:var(--c);border:1px solid var(--line);border-radius:10px;padding:12px 14px;font-size:13px;color:#444;line-height:1.5;}
  .ma-lead-ico{font-size:16px;margin-bottom:5px;}

  /* CONVERSATION */
  .ma-step-dots{display:flex;justify-content:center;gap:6px;margin-bottom:6px;}
  .ma-step-dot{width:8px;height:8px;border-radius:50%;background:var(--line);transition:background .2s;}
  .ma-step-dot.done{background:var(--g);}
  .ma-step-dot.active{background:var(--o);transform:scale(1.2);}
  .ma-step-info{text-align:center;font-size:11px;font-weight:700;letter-spacing:.1em;text-transform:uppercase;color:#BBB;margin-bottom:20px;}

  .ma-messages{display:flex;flex-direction:column;gap:14px;margin-bottom:18px;}
  .ma-msg{display:flex;gap:10px;align-items:flex-start;}
  .ma-msg.user{flex-direction:row-reverse;}
  .ma-msg-av{width:32px;height:32px;border-radius:50%;flex-shrink:0;display:flex;align-items:center;justify-content:center;font-size:13px;font-weight:700;}
  .ma-msg.clara .ma-msg-av{background:var(--g);color:var(--o);font-family:'Playfair Display',serif;font-size:14px;}
  .ma-msg.user .ma-msg-av{background:var(--o);color:#fff;}
  .ma-msg-bubble{max-width:78%;padding:13px 16px;font-size:14px;line-height:1.65;white-space:pre-wrap;}
  .ma-msg.clara .ma-msg-bubble{background:#fff;border:1px solid var(--line);border-radius:16px 16px 16px 4px;color:#333;}
  .ma-msg.user .ma-msg-bubble{background:var(--g);color:#F6F2EC;border-radius:16px 16px 4px 16px;}

  .ma-input-wrap{display:flex;gap:10px;align-items:flex-end;background:#fff;border:1.5px solid var(--line);border-radius:14px;padding:12px 16px;transition:border-color .15s;}
  .ma-input-wrap:focus-within{border-color:var(--g);}
  .ma-input-wrap textarea{flex:1;border:none;outline:none;resize:none;font-size:14.5px;font-family:'Inter',sans-serif;color:var(--d);line-height:1.6;background:transparent;min-height:44px;max-height:120px;}
  .ma-input-wrap textarea::placeholder{color:#C0B8B0;}
  .ma-send{background:var(--g);color:#F6F2EC;border:none;border-radius:10px;padding:10px 18px;font-size:13.5px;font-weight:700;font-family:'Inter',sans-serif;cursor:pointer;flex-shrink:0;align-self:flex-end;transition:background .15s;}
  .ma-send:hover{background:#0E2820;}
  .ma-send:disabled{opacity:.4;cursor:not-allowed;}

  /* FICHE */
  .ma-fiche{background:#fff;border-radius:20px;overflow:hidden;box-shadow:0 4px 6px rgba(23,59,52,0.04),0 20px 40px rgba(23,59,52,0.10);margin-top:20px;}
  .ma-fiche-header{background:var(--g);padding:26px 28px;position:relative;overflow:hidden;}
  .ma-fiche-header::before{content:'';position:absolute;top:-60px;right:-60px;width:200px;height:200px;border-radius:50%;background:rgba(228,87,46,0.1);pointer-events:none;}
  .ma-fiche-badge{display:inline-flex;align-items:center;gap:6px;background:rgba(228,87,46,0.2);border:1px solid rgba(228,87,46,0.35);color:var(--o);font-size:10px;font-weight:700;padding:4px 12px;border-radius:999px;letter-spacing:.1em;margin-bottom:12px;position:relative;z-index:2;}
  .ma-fiche-name{font-family:'Playfair Display',serif;font-size:22px;font-weight:700;color:#fff;margin-bottom:4px;position:relative;z-index:2;}
  .ma-fiche-sub{font-size:11px;color:rgba(246,242,236,0.4);letter-spacing:.08em;text-transform:uppercase;position:relative;z-index:2;}
  .ma-fiche-body{padding:24px 28px;display:flex;flex-direction:column;gap:16px;}
  .ma-fiche-block{background:#FDFCFA;border:1px solid var(--line);border-radius:14px;overflow:hidden;}
  .ma-fiche-bhead{background:var(--c);padding:10px 16px;border-bottom:1px solid var(--line);display:flex;align-items:center;gap:8px;}
  .ma-fiche-bico{font-size:14px;}
  .ma-fiche-blbl{font-size:10px;font-weight:700;letter-spacing:.12em;text-transform:uppercase;color:#AAA09A;}
  .ma-fiche-bbody{padding:14px 16px;font-size:14px;color:#333;line-height:1.7;}
  .ma-fiche-dark{background:linear-gradient(135deg,var(--g),#1E4D44);border-radius:14px;padding:20px 22px;}
  .ma-fiche-dark-lbl{font-size:10px;font-weight:700;letter-spacing:.12em;text-transform:uppercase;color:rgba(246,242,236,0.4);margin-bottom:8px;}
  .ma-fiche-dark-text{font-family:'Playfair Display',serif;font-size:15px;font-style:italic;line-height:1.6;color:#F6F2EC;}
  .ma-fiche-grid{display:grid;grid-template-columns:1fr 1fr;gap:10px;}
  .ma-fiche-stat{background:var(--c);border:1px solid var(--line);border-radius:10px;padding:12px;text-align:center;}
  .ma-fiche-stat-val{font-family:'Playfair Display',serif;font-size:18px;font-weight:700;color:var(--g);margin-bottom:3px;}
  .ma-fiche-stat-lbl{font-size:9.5px;color:#AAA09A;letter-spacing:.04em;}
  .ma-fiche-footer{display:flex;justify-content:space-between;align-items:center;padding:14px 28px;border-top:1px solid var(--line);background:#FDFCFA;}
  .ma-fiche-logo{height:22px;width:auto;}
  .ma-fiche-dl{background:var(--g);color:#F6F2EC;border:none;border-radius:999px;padding:9px 20px;font-size:12.5px;font-weight:700;cursor:pointer;font-family:'Inter',sans-serif;display:flex;align-items:center;gap:7px;}

  /* RDV STRATVENTE */
  .ma-rdv{
    background:linear-gradient(135deg,var(--g) 0%,#0E2820 100%);
    border-radius:24px;padding:40px 36px;margin-top:32px;
    position:relative;overflow:hidden;
    box-shadow:0 20px 48px rgba(23,59,52,0.25);
  }
  .ma-rdv::before{content:'';position:absolute;top:-80px;right:-80px;width:300px;height:300px;border-radius:50%;background:rgba(228,87,46,0.12);pointer-events:none;}
  .ma-rdv::after{content:'';position:absolute;bottom:-60px;left:-60px;width:200px;height:200px;border-radius:50%;background:rgba(246,242,236,0.04);pointer-events:none;}
  .ma-rdv-eyebrow{display:flex;align-items:center;gap:8px;font-size:10.5px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;color:var(--o);margin-bottom:16px;position:relative;z-index:2;}
  .ma-rdv-eyebrow::before{content:'';width:20px;height:2px;background:var(--o);}
  .ma-rdv h2{font-family:'Playfair Display',serif;font-size:clamp(22px,3vw,30px);color:#fff;font-weight:700;line-height:1.2;margin-bottom:14px;position:relative;z-index:2;}
  .ma-rdv h2 em{font-style:italic;color:var(--o);}
  .ma-rdv-desc{font-size:15px;color:rgba(246,242,236,0.6);line-height:1.75;margin-bottom:28px;max-width:520px;position:relative;z-index:2;font-weight:300;}
  .ma-rdv-checks{display:flex;flex-direction:column;gap:10px;margin-bottom:32px;position:relative;z-index:2;}
  .ma-rdv-check{display:flex;align-items:flex-start;gap:12px;font-size:14px;color:rgba(246,242,236,0.85);line-height:1.55;}
  .ma-rdv-check-ico{width:22px;height:22px;border-radius:50%;background:rgba(228,87,46,0.2);border:1px solid rgba(228,87,46,0.4);display:flex;align-items:center;justify-content:center;flex-shrink:0;margin-top:1px;}
  .ma-rdv-check-ico svg{display:block;}
  .ma-rdv-btns{display:flex;align-items:center;gap:14px;flex-wrap:wrap;position:relative;z-index:2;}
  .ma-rdv-btn{
    background:var(--o);color:#fff;border:none;border-radius:999px;
    padding:15px 30px;font-size:15px;font-weight:700;cursor:pointer;
    font-family:'Inter',sans-serif;display:flex;align-items:center;gap:9px;
    box-shadow:0 6px 20px rgba(228,87,46,0.4);
    transition:all .15s;text-decoration:none;
  }
  .ma-rdv-btn:hover{transform:translateY(-2px);box-shadow:0 10px 28px rgba(228,87,46,0.5);}
  .ma-rdv-note{font-size:13px;color:rgba(246,242,236,0.35);position:relative;z-index:2;}
  .ma-rdv-proof{
    display:grid;grid-template-columns:repeat(3,1fr);gap:12px;
    margin-bottom:30px;position:relative;z-index:2;
  }
  .ma-rdv-proof-item{background:rgba(255,255,255,0.06);border:1px solid rgba(255,255,255,0.08);border-radius:14px;padding:16px;text-align:center;}
  .ma-rdv-proof-val{font-family:'Playfair Display',serif;font-size:24px;font-weight:700;color:var(--o);margin-bottom:4px;}
  .ma-rdv-proof-lbl{font-size:11px;color:rgba(246,242,236,0.4);line-height:1.4;}

  .ma-rdv-testimonial{
    background:rgba(255,255,255,0.06);border:1px solid rgba(255,255,255,0.1);
    border-radius:14px;padding:20px 22px;margin-bottom:28px;
    position:relative;z-index:2;
  }
  .ma-rdv-testimonial p{font-size:14px;color:rgba(246,242,236,0.75);line-height:1.7;font-style:italic;font-family:'Playfair Display',serif;margin-bottom:10px;}
  .ma-rdv-testimonial .author{font-size:12px;color:rgba(246,242,236,0.35);font-weight:600;font-style:normal;font-family:'Inter',sans-serif;}

  /* NAV BTNS */
  .ma-nav{display:flex;justify-content:space-between;align-items:center;margin-top:32px;gap:12px;}
  .ma-btn-primary{background:var(--g);color:#F6F2EC;border:none;border-radius:999px;padding:13px 28px;font-size:14.5px;font-weight:700;cursor:pointer;font-family:'Inter',sans-serif;display:flex;align-items:center;gap:8px;box-shadow:0 4px 14px rgba(23,59,52,0.25);transition:all .15s;}
  .ma-btn-primary:hover{background:#0E2820;transform:translateY(-1px);}
  .ma-btn-primary:disabled{opacity:.4;cursor:not-allowed;transform:none;}
  .ma-btn-secondary{background:transparent;color:var(--g);border:1.5px solid var(--line);border-radius:999px;padding:12px 24px;font-size:14px;font-weight:600;cursor:pointer;font-family:'Inter',sans-serif;}
  .ma-btn-secondary:hover{border-color:var(--g);}

  @media(max-width:640px){
    .ma-grid,.ma-canal-grid,.ma-metriques,.ma-3q,.ma-lead-grid,.ma-fiche-grid,.ma-rdv-proof{grid-template-columns:1fr;}
    .ma-rdv{padding:28px 20px;}
    .ma-rdv-btns{flex-direction:column;}
    .ma-rdv-btn{width:100%;justify-content:center;}
  }
`;

// ─── PARSERS CONTEXTE PRÉCÉDENT ───────────────────────────────
function extractFromContext(contextePrecedent) {
  const result = { nomMarque:'', prenom:'', metier:'', frustration:'', jtbd:'', vision:'', raisonEtre:'', offre:'' };
  if (!contextePrecedent || !contextePrecedent.length) return result;

  contextePrecedent.forEach(rep => {
    const c = rep.contenu || '';
    const get = (key) => { const m = c.match(new RegExp(key + ':?\\s*(.+?)(?:\\n|$)')); return m ? m[1].trim() : ''; };
    if (rep.numeroModule === 1) {
      result.nomMarque = get('NOM_MARQUE') || get('NOM_MARQUE:');
      result.vision = get('VISION_3ANS');
    }
    if (rep.numeroModule === 2) {
      result.prenom = get('PERSONA_PRENOM');
      result.metier = get('PERSONA_METIER');
      result.frustration = get('PERSONA_FRUSTRATIONS') ? get('PERSONA_FRUSTRATIONS').split('|')[0].trim() : '';
      result.jtbd = get('PERSONA_JTBD');
    }
    if (rep.numeroModule === 3) result.raisonEtre = get('RAISON_ETRE') || get('MISSION');
    if (rep.numeroModule === 6) result.offre = get('OFFRE_NOM') || get('NOM_OFFRE');
  });
  return result;
}

// ─── QUESTIONS CONVERSATIONNELLES ────────────────────────────
const QUESTIONS = [
  {
    label: 'Canal principal',
    q: (ctx) => ctx.prenom
      ? `${ctx.prenom} cherche "${ctx.jtbd || 'une solution'}". Quel canal utilise-t-il pour trouver ce genre de solution : Google, LinkedIn/email, Instagram/TikTok/Facebook ou SEO ? Justifie ton choix en 2-3 lignes, et dis-moi comment tu comptes l'atteindre concrètement sur ce canal.`
      : "Quel canal principal vas-tu utiliser pour les 90 prochains jours : Google, LinkedIn/email, Instagram/TikTok/Facebook ou SEO ? Justifie en 2-3 lignes.",
  },
  {
    label: 'Message par stade',
    q: (ctx) => `Adaptons ton message aux 5 stades de ton prospect. Pour chaque stade, donne-moi une phrase concrète que tu pourrais publier ou envoyer :\n\n1. Prise de conscience du problème\n2. Découverte des solutions\n3. Comparaison (pourquoi toi)\n4. Confiance et réassurance\n5. Passage à l'action${ctx.prenom ? `\n\nPense à ${ctx.prenom} : ${ctx.frustration || 'ses frustrations spécifiques'}.` : ''}`,
  },
  {
    label: 'Lead magnet',
    q: (ctx) => `Quelle ressource gratuite vas-tu créer pour capter les coordonnées de tes prospects ? Choisis parmi : checklist, guide court, diagnostic, simulateur, étude de cas ou mini-formation. Précise le sujet exact et la promesse.${ctx.nomMarque ? ` En lien avec ${ctx.nomMarque}.` : ''}`,
  },
  {
    label: 'Parcours 4 étapes',
    q: (ctx) => `Décris ton parcours d'acquisition en 4 étapes concrètes :\n\n🔵 Attirer, quelle action ou contenu spécifique ?\n📄 Informer, quelle ressource ou page ?\n💬 Convertir, comment tu réponds et relances ?\n🌟 Fidéliser, comment tu gardes le contact ?`,
  },
  {
    label: 'Métriques',
    q: () => `Quels indicateurs vas-tu suivre chaque semaine ? Parmi ces 6 : prospects générés, coût par prospect, ventes, taux de conversion, coût d'acquisition, marge. Pour chacun que tu retiens, dis-moi comment tu vas le mesurer concrètement.`,
  },
  {
    label: 'Actions J+7',
    q: (ctx) => `Dernière question, la plus importante. Tu as maintenant un système d'acquisition structuré. Quelles sont les 3 actions concrètes que tu vas mettre en place dans les 7 prochains jours pour le lancer ?${ctx.nomMarque ? ` Pour ${ctx.nomMarque}.` : ''}`,
  },
];

// ─── FICHE ACQUISITION ───────────────────────────────────────
function parseFicheAcquisition(synthese) {
  if (!synthese) return null;
  const r = { canal:'', cible:'', messages:'', leadMagnet:'', parcours:'', metriques:'', actions:'', synthese:'' };
  try {
    const keys = ['ACQ_CANAL','ACQ_CIBLE','ACQ_MESSAGES','ACQ_LEAD_MAGNET','ACQ_PARCOURS','ACQ_METRIQUES','ACQ_ACTIONS_J7','SYNTHESE'];
    let n = synthese;
    keys.forEach(k => { n = n.replace(new RegExp('\\s+' + k + ':', 'g'), '\n' + k + ':'); });
    n.split('\n').forEach(line => {
      const t = line.trim();
      const get = (k) => t.startsWith(k) ? t.slice(k.length).trim() : null;
      if (get('ACQ_CANAL:')) r.canal = get('ACQ_CANAL:');
      if (get('ACQ_CIBLE:')) r.cible = get('ACQ_CIBLE:');
      if (get('ACQ_MESSAGES:')) r.messages = get('ACQ_MESSAGES:');
      if (get('ACQ_LEAD_MAGNET:')) r.leadMagnet = get('ACQ_LEAD_MAGNET:');
      if (get('ACQ_PARCOURS:')) r.parcours = get('ACQ_PARCOURS:');
      if (get('ACQ_METRIQUES:')) r.metriques = get('ACQ_METRIQUES:');
      if (get('ACQ_ACTIONS_J7:')) r.actions = get('ACQ_ACTIONS_J7:');
      if (get('SYNTHESE:')) r.synthese = get('SYNTHESE:');
    });
  } catch(e){}
  return r.canal || r.parcours ? r : null;
}

function FicheAcquisition({ synthese, ctx }) {
  const ficheRef = useRef(null);
  const data = parseFicheAcquisition(synthese);
  if (!data) return null;

  const handleDownload = () => {
    const el = ficheRef.current;
    if (!el) return;
    const script = document.createElement('script');
    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js';
    document.head.appendChild(script);
    script.onload = () => {
      window.html2canvas(el, { scale: 2, useCORS: true, backgroundColor: '#ffffff' }).then(canvas => {
        const link = document.createElement('a');
        link.download = `plan-acquisition-${(ctx.nomMarque||'marque').toLowerCase().replace(/\s+/g,'-')}.png`;
        link.href = canvas.toDataURL('image/png');
        link.click();
      });
    };
  };

  const blocks = [
    { ico:'📡', lbl:'Canal principal', val: data.canal },
    { ico:'💬', lbl:'Messages par stade', val: data.messages },
    { ico:'🎁', lbl:'Lead magnet', val: data.leadMagnet },
    { ico:'🔄', lbl:'Parcours acquisition', val: data.parcours },
    { ico:'📊', lbl:'Métriques suivies', val: data.metriques },
  ].filter(b => b.val);

  const actions = data.actions ? data.actions.split('|').map(a => a.trim()).filter(Boolean) : [];

  return (
    <div ref={ficheRef} className="ma-fiche">
      <div className="ma-fiche-header">
        <div className="ma-fiche-badge">MODULE ACQUISITION</div>
        <div className="ma-fiche-name">Plan d'acquisition {ctx.nomMarque ? `— ${ctx.nomMarque}` : ''}</div>
        <div className="ma-fiche-sub">90 jours · BrandStarter</div>
      </div>
      <div className="ma-fiche-body">
        {blocks.map((b,i) => (
          <div key={i} className="ma-fiche-block">
            <div className="ma-fiche-bhead"><span className="ma-fiche-bico">{b.ico}</span><span className="ma-fiche-blbl">{b.lbl}</span></div>
            <div className="ma-fiche-bbody">{b.val}</div>
          </div>
        ))}
        {actions.length > 0 && (
          <div className="ma-fiche-dark">
            <div className="ma-fiche-dark-lbl">🚀 Actions J+7</div>
            {actions.map((a,i) => (
              <div key={i} className="ma-fiche-dark-text" style={{marginBottom: i < actions.length-1 ? 8 : 0}}>
                {i+1}. {a}
              </div>
            ))}
          </div>
        )}
        {data.synthese && (
          <div style={{background:'rgba(228,87,46,0.07)',border:'1px solid rgba(228,87,46,0.2)',borderRadius:14,padding:'16px 18px'}}>
            <div style={{fontSize:10,fontWeight:700,letterSpacing:'.12em',textTransform:'uppercase',color:'var(--o)',marginBottom:8}}>Synthèse Clara</div>
            <div style={{fontSize:14,color:'#444',lineHeight:1.7}}>{data.synthese}</div>
          </div>
        )}
      </div>
      <div className="ma-fiche-footer">
        <div style={{display:'flex',alignItems:'center',gap:8}}>
          <img src={logoBrandStarter} alt="BrandStarter" className="ma-fiche-logo"/>
          <span style={{fontSize:'10.5px',color:'#C0B8B0'}}>Plan d'acquisition · 90 jours</span>
        </div>
        <button className="ma-fiche-dl" onClick={handleDownload}>
          <svg width="13" height="13" viewBox="0 0 16 16" fill="none"><path d="M8 2v8M5 7l3 3 3-3M3 13h10" stroke="#F6F2EC" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>
          Télécharger
        </button>
      </div>
    </div>
  );
}

// ─── COMPOSANT PRINCIPAL ──────────────────────────────────────
export function ModuleAcquisition({ moduleValide, syntheseExistante, onValidate, contextePrecedent }) {
  const ctx = extractFromContext(contextePrecedent || []);
  const [phase, setPhase] = useState(moduleValide ? 'done' : 'formation');
  const [formationStep, setFormationStep] = useState(0);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [convStep, setConvStep] = useState(0);
  const [synthese, setSynthese] = useState(syntheseExistante || '');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const chatEndRef = useRef(null);

  useEffect(() => { chatEndRef.current?.scrollIntoView({ behavior: 'smooth' }); }, [messages]);

  useEffect(() => {
    if (phase === 'conversation' && messages.length === 0) {
      const firstQ = QUESTIONS[0].q(ctx);
      setMessages([{ role: 'assistant', content: `Parfait, on attaque ton plan d'acquisition.${ctx.prenom ? ` J'ai bien ton persona ${ctx.prenom} en tête.` : ''} On va construire ensemble un système simple et mesurable.\n\n${firstQ}` }]);
    }
  }, [phase]);

  const totalParts = 6;
  const progress = phase === 'formation'
    ? ((formationStep + 1) / (totalParts + 2)) * 100
    : phase === 'conversation' ? ((totalParts + 1 + convStep/QUESTIONS.length) / (totalParts + 2)) * 100
    : 100;

  const sendMessage = async () => {
    if (!input.trim() || loading) return;
    const userMsg = { role: 'user', content: input.trim() };
    const newMsgs = [...messages, userMsg];
    setMessages(newMsgs);
    setInput('');
    setLoading(true);
    setError('');
    try {
      const nextStep = convStep + 1;
      if (nextStep < QUESTIONS.length) {
        const nextQ = QUESTIONS[nextStep].q(ctx);
        const prompt = buildChallengePrompt(convStep, input.trim(), nextQ, ctx, newMsgs);
        const res = await api.chatIA(9, {
          conversation: [{ role: 'user', content: prompt }],
          tourActuel: convStep,
          contextePrecedent
        });
        setMessages(prev => [...prev, { role: 'assistant', content: res.message }]);
        setConvStep(nextStep);
      } else {
        const prompt = buildSynthesePrompt(newMsgs, ctx);
        const res = await api.chatIA(9, {
          conversation: [{ role: 'user', content: prompt }],
          tourActuel: 99,
          contextePrecedent
        });
        setMessages(prev => [...prev, { role: 'assistant', content: "Excellent travail. Voici ton plan d'acquisition structuré..." }]);
        setSynthese(res.message);
        setPhase('done');
      }
    } catch(e) { setError(e.message); }
    finally { setLoading(false); }
  };

  const buildChallengePrompt = (step, answer, nextQ, ctx, msgs) => `Tu es Clara, guide BrandStarter. Tu construis le plan d'acquisition client de l'utilisateur.

ÉTAPE ${step + 1}/${QUESTIONS.length}
RÉPONSE : "${answer}"
${ctx.prenom ? `PERSONA : ${ctx.prenom}, ${ctx.metier || ''}, frustration : ${ctx.frustration || ''}` : ''}
${ctx.nomMarque ? `MARQUE : ${ctx.nomMarque}` : ''}

1. Réagis à la réponse en 1-2 phrases. Challenge si trop vague. Valide si précis.
2. Enchaîne DIRECTEMENT avec cette question : ${nextQ}

RÈGLES : tutoiement, jamais de tiret "—", max 5 lignes total, bienveillant mais exigeant.`;

  const buildSynthesePrompt = (msgs, ctx) => {
    const userAnswers = msgs.filter(m => m.role === 'user').map((m,i) => `Q${i+1}: ${m.content}`).join('\n\n');
    return `Tu es Clara, guide BrandStarter. Génère un plan d'acquisition structuré basé sur ces réponses.

${ctx.nomMarque ? `MARQUE : ${ctx.nomMarque}` : ''}
${ctx.prenom ? `PERSONA : ${ctx.prenom}, ${ctx.metier || ''}, ${ctx.frustration || ''}` : ''}

RÉPONSES :
${userAnswers}

FORMAT EXACT (une clé par ligne) :
ACQ_CANAL: [canal choisi + justification en 2 lignes]
ACQ_CIBLE: [description précise de la cible sur ce canal]
ACQ_MESSAGES: [message pour chaque stade en une phrase chacun, séparés par |]
ACQ_LEAD_MAGNET: [format + sujet + promesse]
ACQ_PARCOURS: [Attirer : action | Informer : action | Convertir : action | Fidéliser : action]
ACQ_METRIQUES: [métrique1 : comment mesurer | métrique2 : comment mesurer | ...]
ACQ_ACTIONS_J7: [action 1|action 2|action 3]
SYNTHESE: [synthèse narrative en 3 phrases]`;
  };

  const handleKeyDown = (e) => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendMessage(); } };

  const FORMATION_PARTS = [
    {
      num: 'Partie 1',
      titre: "Le piège de l'acquisition au jour le jour",
      content: () => (
        <>
          <p>Quand on lance son activité, le premier réflexe est souvent de chercher des clients au jour le jour. On publie un peu, on contacte quelques personnes, on compte sur le bouche-à-oreille… puis on recommence le mois suivant.</p>
          <div className="ma-hl orange">Le problème : sans système d'acquisition, ton activité dépend du hasard. Et le hasard est un très mauvais associé.</div>
          <p>Ta priorité est de rendre l'arrivée de prospects <strong>prévisible</strong>. Pour ça, tu dois pouvoir répondre à 3 questions simples :</p>
          <div className="ma-3q">
            {[
              {ico:'❓',q:"D'où viennent mes prospects ?"},
              {ico:'💶',q:"Combien me coûte un nouveau client ?"},
              {ico:'📅',q:"Combien de clients puis-je espérer le mois prochain ?"},
            ].map((item,i) => (
              <div key={i} className="ma-3q-item">
                <div className="ma-3q-ico">{item.ico}</div>
                <div className="ma-3q-q">{item.q}</div>
              </div>
            ))}
          </div>
          {ctx.nomMarque && <div className="ma-clara"><div className="ma-clara-av">C</div><div><div className="ma-clara-name">Clara</div><div className="ma-clara-text">Pour {ctx.nomMarque}, on va construire ce système ensemble. Et on va s'appuyer sur ce qu'on sait déjà de ton persona{ctx.prenom ? ` ${ctx.prenom}` : ''} pour ne pas repartir de zéro.</div></div></div>}
        </>
      )
    },
    {
      num: 'Partie 2',
      titre: "Choisir un seul canal pour 90 jours",
      content: () => (
        <>
          <p>Ne cherche pas à être partout. <strong>Choisis un canal principal pour les 90 prochains jours.</strong> Maîtrise-le, mesure ses résultats, améliore-le. Puis seulement tu en ajoutes un deuxième.</p>
          <div className="ma-canal-grid">
            {[
              {ico:'🔍',name:'Google & SEA',quand:"Si tes clients recherchent déjà ta solution",desc:"Idéal pour les services avec une demande existante. Le prospect est en mode achat."},
              {ico:'💼',name:'LinkedIn & Email',quand:"Si tu vends à des entreprises (B2B)",desc:"Prospection directe, contenu expert, networking. Le cycle de vente est plus long mais la valeur est élevée."},
              {ico:'📸',name:'Instagram / TikTok / Facebook',quand:"Si ton activité repose sur la visibilité et la confiance",desc:"Parfait pour les coachs, créatifs, formateurs. Tu construis une audience qui te fait confiance avant d'acheter."},
              {ico:'📝',name:'SEO & contenu',quand:"Si tes prospects se renseignent avant d'acheter",desc:"Investissement long terme mais trafic organique durable. Idéal pour les sujets avec forte recherche."},
            ].map((c,i) => (
              <div key={i} className="ma-canal">
                <div className="ma-canal-head"><span className="ma-canal-ico">{c.ico}</span><span className="ma-canal-name">{c.name}</span></div>
                <div className="ma-canal-quand">{c.quand}</div>
                <div className="ma-canal-desc">{c.desc}</div>
              </div>
            ))}
          </div>
          {ctx.prenom && <div className="ma-hl">Rappel : ton persona <strong>{ctx.prenom}</strong> ({ctx.metier || 'ton client idéal'}), où cherche-t-il des solutions à son problème ? C'est là que tu dois être.</div>}
        </>
      )
    },
    {
      num: 'Partie 3',
      titre: "Les 5 stades du prospect : parle au bon moment",
      content: () => (
        <>
          <p>Un prospect qui découvre son problème n'a pas besoin du même discours qu'une personne prête à acheter. <strong>Ta communication doit l'aider à progresser</strong> vers la décision.</p>
          <div className="ma-funnel">
            {[
              ['Prise de conscience','Il réalise qu\'il a un problème. Montre-lui qu\'il n\'est pas seul.'],
              ['Découverte des solutions','Il explore les options. Éduque-le sur ce qui existe.'],
              ['Comparaison','Il évalue. Explique pourquoi ta solution est la plus adaptée.'],
              ['Confiance','Il hésite. Rassure avec des preuves, témoignages, garanties.'],
              ['Passage à l\'action','Il est prêt. Facilite la décision avec un appel à l\'action clair.'],
            ].map(([title,desc],i) => (
              <div key={i} className="ma-funnel-step">
                <div className="ma-funnel-num">{i+1}</div>
                <div><strong>{title}</strong><span>{desc}</span></div>
              </div>
            ))}
          </div>
        </>
      )
    },
    {
      num: 'Partie 4',
      titre: "Construis un parcours simple en 4 étapes",
      content: () => (
        <>
          <div className="ma-grid">
            {[
              {ico:'📣',t:'Attirer',d:'Publie un contenu ou une publicité qui répond à une vraie préoccupation de ton persona.'},
              {ico:'📄',t:'Informer',d:'Propose une ressource utile ou une page claire qui présente ta solution.'},
              {ico:'🤝',t:'Convertir',d:'Réponds rapidement, lève les objections et relance les demandes non finalisées.'},
              {ico:'⭐',t:'Fidéliser',d:'Demande un avis, encourage la recommandation et garde le contact avec tes clients.'},
            ].map((item,i) => (
              <div key={i} className="ma-gi">
                <div className="ma-gi-ico">{item.ico}</div>
                <div className="ma-gi-title">{item.t}</div>
                <div className="ma-gi-desc">{item.d}</div>
              </div>
            ))}
          </div>
          <div className="ma-hl">Même simple, ce parcours sera déjà bien plus efficace qu'une succession d'actions isolées.</div>
        </>
      )
    },
    {
      num: 'Partie 5',
      titre: "Le lead magnet : crée une raison de laisser ses coordonnées",
      content: () => (
        <>
          <p>Un prospect ne donne jamais son email uniquement pour recevoir tes offres. <strong>Propose-lui quelque chose d'utile en échange</strong>, une ressource qui résout un problème précis et prépare naturellement la vente.</p>
          <div className="ma-lead-grid">
            {[
              {ico:'✅',t:'Checklist'},
              {ico:'📖',t:'Guide court'},
              {ico:'🔍',t:'Diagnostic'},
              {ico:'🧮',t:'Simulateur'},
              {ico:'📊',t:'Étude de cas'},
              {ico:'🎓',t:'Mini-formation'},
            ].map((l,i) => (
              <div key={i} className="ma-lead">
                <div className="ma-lead-ico">{l.ico}</div>
                <strong>{l.t}</strong>
              </div>
            ))}
          </div>
          {ctx.prenom && <div className="ma-clara"><div className="ma-clara-av">C</div><div><div className="ma-clara-name">Clara</div><div className="ma-clara-text">En pensant à {ctx.prenom} ({ctx.frustration || 'son problème principal'}), quel format lui serait le plus utile ? Ce que tu offres doit répondre exactement à ce qu'il cherche à ce stade de sa réflexion.</div></div></div>}
        </>
      )
    },
    {
      num: 'Partie 6',
      titre: "Les 6 métriques à suivre absolument",
      content: () => (
        <>
          <p>Sans ces données, <strong>tu ne sais pas réellement si ton acquisition fonctionne.</strong> Ce ne sont pas des chiffres compliqués, ce sont des indicateurs de pilotage simples.</p>
          <div className="ma-metriques">
            {[
              {ico:'👥',name:'Prospects générés',desc:'Combien de contacts qualifiés par semaine'},
              {ico:'💶',name:'Coût par prospect',desc:'Budget dépensé / prospects obtenus'},
              {ico:'🛒',name:'Ventes',desc:'Nombre de clients signés sur la période'},
              {ico:'📈',name:'Taux de conversion',desc:'% prospects qui deviennent clients'},
              {ico:'💰',name:'Coût d\'acquisition',desc:'Coût total pour obtenir 1 client'},
              {ico:'📊',name:'Marge obtenue',desc:'Ce qu\'il reste après tes coûts d\'acquisition'},
            ].map((m,i) => (
              <div key={i} className="ma-met">
                <div className="ma-met-ico">{m.ico}</div>
                <div className="ma-met-name">{m.name}</div>
                <div className="ma-met-desc">{m.desc}</div>
              </div>
            ))}
          </div>
          <div className="ma-hl orange">Un système simple, lancé rapidement et amélioré chaque semaine, vaut bien mieux qu'une stratégie parfaite qui n'existe que sur le papier.</div>
        </>
      )
    }
  ];

  return (
    <div className="ma">
      <style>{CSS}</style>

      <div className="ma-progress">
        <div className="ma-progress-fill" style={{width:`${progress}%`}}></div>
      </div>

      {/* CONTEXTE BANNER */}
      {(ctx.nomMarque || ctx.prenom) && (
        <div className="ma-context">
          <div className="ma-context-ico">🔗</div>
          <div>
            <div className="ma-context-text">
              <strong>Ce module utilise tes données déjà saisies.</strong> Pas besoin de tout réexpliquer à Clara.
            </div>
            <div className="ma-context-tags">
              {ctx.nomMarque && <span className="ma-tag">🏷️ {ctx.nomMarque}</span>}
              {ctx.prenom && <span className="ma-tag">👤 Persona : {ctx.prenom}</span>}
              {ctx.metier && <span className="ma-tag">💼 {ctx.metier}</span>}
              {ctx.vision && <span className="ma-tag">🚀 Vision définie</span>}
            </div>
          </div>
        </div>
      )}

      {/* ── FORMATION ── */}
      {phase === 'formation' && (
        <div className="ma-formation">
          {FORMATION_PARTS.map((part, idx) => (
            idx <= formationStep && (
              <div key={idx} className="ma-part">
                <div className="ma-eyebrow">{part.num}</div>
                <h2>{part.titre}</h2>
                {part.content()}
              </div>
            )
          ))}
          <div className="ma-nav">
            {formationStep > 0
              ? <button className="ma-btn-secondary" onClick={() => setFormationStep(s => s-1)}>← Précédent</button>
              : <div/>
            }
            {formationStep < FORMATION_PARTS.length - 1 ? (
              <button className="ma-btn-primary" onClick={() => setFormationStep(s => s+1)}>
                Partie suivante <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M3 8h10M9 4l4 4-4 4" stroke="#F6F2EC" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>
              </button>
            ) : (
              <button className="ma-btn-primary" onClick={() => setPhase('conversation')}>
                Construire mon plan avec Clara <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M3 8h10M9 4l4 4-4 4" stroke="#F6F2EC" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>
              </button>
            )}
          </div>
        </div>
      )}

      {/* ── CONVERSATION ── */}
      {phase === 'conversation' && (
        <div>
          <div className="ma-step-dots">
            {QUESTIONS.map((_,i) => <div key={i} className={`ma-step-dot ${i < convStep ? 'done' : i === convStep ? 'active' : ''}`}/>)}
          </div>
          <div className="ma-step-info">Question {Math.min(convStep+1, QUESTIONS.length)} / {QUESTIONS.length} · {QUESTIONS[Math.min(convStep, QUESTIONS.length-1)].label}</div>
          <div className="ma-messages">
            {messages.map((msg, i) => (
              <div key={i} className={`ma-msg ${msg.role === 'assistant' ? 'clara' : 'user'}`}>
                <div className="ma-msg-av">{msg.role === 'assistant' ? 'C' : '✎'}</div>
                <div className="ma-msg-bubble">{msg.content}</div>
              </div>
            ))}
            {loading && (
              <div className="ma-msg clara">
                <div className="ma-msg-av">C</div>
                <div className="ma-msg-bubble" style={{color:'#AAA'}}>Clara réfléchit...</div>
              </div>
            )}
            <div ref={chatEndRef}/>
          </div>
          {error && <div style={{color:'#DC2626',fontSize:13,marginBottom:12}}>{error}</div>}
          <div className="ma-input-wrap">
            <textarea value={input} onChange={e => setInput(e.target.value)} onKeyDown={handleKeyDown} placeholder="Écris ta réponse à Clara" rows={2} disabled={loading}/>
            <button className="ma-send" onClick={sendMessage} disabled={loading || !input.trim()}>Envoyer</button>
          </div>
        </div>
      )}

      {/* ── DONE ── */}
      {phase === 'done' && (
        <div>
          <FicheAcquisition synthese={synthese} ctx={ctx}/>

          {/* CTA STRATVENTE */}
          <div className="ma-rdv">
            <div className="ma-rdv-eyebrow">La prochaine étape avec Stratvente</div>
            <h2>Tu as le plan.<br/>Maintenant, <em>passons à l'action ensemble.</em></h2>
            <p className="ma-rdv-desc">
              Un plan d'acquisition, ça se construit. Mais les premières semaines sont décisives, c'est là que la plupart des entrepreneurs perdent de l'énergie sur les mauvais canaux, avec les mauvais messages.
              Stratvente est là pour te faire gagner 3 à 6 mois.
            </p>

            <div className="ma-rdv-proof">
              <div className="ma-rdv-proof-item">
                <div className="ma-rdv-proof-val">+200</div>
                <div className="ma-rdv-proof-lbl">TPE et indépendants accompagnés dans les Hauts-de-France</div>
              </div>
              <div className="ma-rdv-proof-item">
                <div className="ma-rdv-proof-val">3 à 6</div>
                <div className="ma-rdv-proof-lbl">Mois gagnés en moyenne sur la mise en place du système</div>
              </div>
              <div className="ma-rdv-proof-item">
                <div className="ma-rdv-proof-val">90j</div>
                <div className="ma-rdv-proof-lbl">Pour avoir un système rodé et des premiers résultats mesurables</div>
              </div>
            </div>

            <div className="ma-rdv-testimonial">
              <p>« Avant Stratvente, je publiais dans le vide. Après 2 séances, j'avais un canal clair, un message précis et mes 3 premiers prospects qualifiés en moins de 30 jours. »</p>
              <div className="author">Client Stratvente · Consultante indépendante, Lille</div>
            </div>

            <div className="ma-rdv-checks">
              {[
                'Un audit de ton plan d\'acquisition pour identifier ce qui bloque vraiment',
                'Un canal prioritaire sélectionné selon ton marché, ta cible et tes ressources',
                'Les messages clés rédigés et testés avec toi, pas juste théorisés',
                'Un tableau de bord simple pour suivre tes métriques chaque semaine',
                'Un accompagnement humain, pas un outil de plus à configurer',
              ].map((check, i) => (
                <div key={i} className="ma-rdv-check">
                  <div className="ma-rdv-check-ico">
                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M2 5.2l2 2 4-4" stroke="#E4572E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                  </div>
                  {check}
                </div>
              ))}
            </div>

            <div className="ma-rdv-btns">
              <a href="https://stratvente.fr/rdv" target="_blank" rel="noreferrer" className="ma-rdv-btn">
                Prendre rendez-vous avec Stratvente
                <svg width="15" height="15" viewBox="0 0 16 16" fill="none"><path d="M3 8h10M9 4l4 4-4 4" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>
              </a>
              <button className="ma-btn-primary" onClick={() => onValidate(synthese)} disabled={saving} style={{background:'rgba(255,255,255,0.1)',boxShadow:'none',border:'1px solid rgba(255,255,255,0.2)'}}>
                {saving ? 'Enregistrement...' : 'Valider le module →'}
              </button>
            </div>
            <div className="ma-rdv-note" style={{marginTop:14}}>Premier échange sans engagement · Dany Dassonville, fondateur Stratvente</div>
          </div>
        </div>
      )}
    </div>
  );
}
